<template>
	<div class="hiq-toc-mobile__wrapper" v-if="isToc && isMobile">
		<div class="hiq-toc-mobile" role="navigation" aria-label="Innehållsförtekning">
			<button
				class="hiq-toc-mobile__dropdown"
				@click="toggleList" 
				aria-controls="tocContainer"
				:aria-expanded="isExpanded ? 'true' : 'false'" >
				 {{ currentItemTitle }}
			</button>
			<ul
				class="hiq-toc-mobile__list"
				v-if="items.length > 0"
				:data-open="isExpanded ? 'true' : 'false'"
				id="tocContainer">
				<li class="hiq-toc-mobile__item"
					v-for="item in items"
					@click="onScroll(item.id)"
					:key="item.id">
					<span class="hiq-toc-mobile__item-link" :id="'link-' + item.id">
						{{ item.title }}
					</span>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	name: 'app',
	data() {
		return {
			observer: null,
			footerObserver: null,
			pageContentObserver: null,
			isMobile: false,
			items: [],
			currentItemTitle: 'Innehåll på sidan',
			isExpanded: false
		}
	},
	computed: {
		isToc(){
			return this.$store.getters.isToc;
		}
	},
	methods: {
		onScroll(id) {
			this.toggleList();
			let element = document.getElementById(id);
			let top = window.pageYOffset + element.getBoundingClientRect().top - 200;

      window.scrollTo({
				top: top,
				behavior: 'smooth' 
			});
		},
		toggleList() {
			this.isExpanded = !this.isExpanded;
		},
		onElementObserved(entries) {
			let element = document.querySelector('.hiq-toc-mobile');
			if(element) {
				entries.forEach(({ target, isIntersecting }) => {
					const plusbox = target.querySelector('span.hiq-plus-box__decoration-title');
					const id = target.getAttribute('id');
					if (isIntersecting) {
						element
							.querySelector(`li span[id="link-${id}"]`)
							.parentElement.classList.add('active') 		
											
						this.currentItemTitle = plusbox ? plusbox.textContent : target.textContent;
					} else {
						element
							.querySelector(`li span[id="link-${id}"]`)
							.parentElement.classList.remove('active')
					}
				})
			}
		},

		onFooterObserved(entries) {
			let element = document.querySelector('.hiq-toc-mobile__wrapper');
			if(element) {
				entries.forEach(({ target, isIntersecting }) => {
					if (isIntersecting) {
						element.classList.add('hide')
					} else {
						element.classList.remove('hide')
					}
				})
			}
		},

		onPageContentObserved(entries) {
			let element = document.querySelector('.hiq-toc-mobile__wrapper');
			if(element) {
				entries.forEach(({ target, isIntersecting }) => {
					if (isIntersecting) {
						element.classList.add('fixed')
					} else {
						element.classList.remove('fixed')
					}
				})
			}
		},
	},
	mounted() {
		// Check if its mobile view
		if(window.innerWidth < 1024){
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
    window.addEventListener('resize', () => {
      if(window.innerWidth < 1024) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    });

		if(this.isMobile) {
			let mittenspaltElement = document.getElementById('Mittenspalt').parentElement;
			let footerElement = document.querySelector('footer');

			mittenspaltElement.querySelectorAll('.hiq-h2').forEach((h2) => {
				const nextSibling = h2.nextElementSibling;
				if (nextSibling && nextSibling.classList.contains('hiq-decoration-collapsable-h2')) {
					return;
				}

				const titleSpan = h2.querySelector('.env-m-right--x-large');

				this.items.push({
					id: h2.id,
					title: titleSpan ? titleSpan.innerHTML : h2.innerHTML,
				})
				this.observer.observe(h2);
			})

			this.footerObserver.observe(footerElement);
     	this.pageContentObserver.observe(mittenspaltElement);
		}
  },
	created() {
		// root = null = document (default root for intersection)
		// rootMargin: '-200px 0px -70% 0px' to trigger earlier when scrolling down
		// threshold: 0 to trigger as soon as even one pixel is visible
		this.observer = new IntersectionObserver(this.onElementObserved, {
			root: null,
			rootMargin: '-200px 0px -70% 0px',
  		threshold: 0
    })

		// Observer for footer
		this.footerObserver = new IntersectionObserver(this.onFooterObserved, {
			root: null,
			threshold: 0.01,
		})

		// Observer for toc-mobile
		this.pageContentObserver = new IntersectionObserver(this.onPageContentObserved, {
			root: null,
			threshold: 0.01,
		})
	},
	beforeDestroy() {
    this.observer.disconnect();
		this.footerObserver.disconnect();
		this.pageContentObserver.disconnect();
  },
}
</script>
